/** The one address users are sent to for support, account and payment questions. */
export const SUPPORT_EMAIL = "contact@zenmusicgroup.com";
